import { render, staticRenderFns } from "./AdminScreensList.vue?vue&type=template&id=c154aade&"
import script from "./AdminScreensList.vue?vue&type=script&lang=js&"
export * from "./AdminScreensList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports